import { useState } from 'react';
import { injectIntl } from 'react-intl';

import { CustomAllowNotifications } from '../common/custom-allow-notifications';

import {
  isNotificationSupported,
  getNotificationPermission,
} from 'utils/NotificationUtils';
import NotificationPermissionsType from '../../constants/NotificationPermissionsType';

import FirebaseService from '../../firebase/firebase';

import useStyles from './AllowNotificationsDialog.styles';

function AllowNotificationsDialog(props) {
  const { logout, children = null } = props;

  const notificationsSupported = isNotificationSupported();
  const permission = getNotificationPermission();
  const isGranted = permission === NotificationPermissionsType.GRANTED;
  const isDenied = permission === NotificationPermissionsType.DENIED;

  const [isNotificationAllowed, setIsNotificationAllowed] = useState(isGranted);
  const [openAllowOrders, setOpenAllowOrders] = useState(false);
  const [isNotificationDenied, setIsNotificationDenied] = useState(isDenied);

  const classes = useStyles();

  const requestPermission = () => {
    if (!notificationsSupported) return;
    FirebaseService.getPermission().then(permissionValue => {
      const _isOk = permissionValue === NotificationPermissionsType.GRANTED;
      setIsNotificationAllowed(_isOk);
      setIsNotificationDenied(permissionValue === 'denied');
      if (_isOk) setTimeout(() => window.location.reload(), 200);
    });
  };

  if (isGranted || isNotificationAllowed || !notificationsSupported) {
    return children;
  }
  return (
    <div className={classes.root}>
      {!openAllowOrders && !isNotificationDenied && (
        <CustomAllowNotifications
          state='initial'
          onAllow={requestPermission}
          onCancel={() => setOpenAllowOrders(true)}
        />
      )}
      {openAllowOrders && !isNotificationDenied && (
        <CustomAllowNotifications
          state='needsConfirmation'
          onAllow={requestPermission}
          onCancel={logout}
        />
      )}
      {isNotificationDenied && (
        <CustomAllowNotifications state='denied' onAcknowledge={logout} />
      )}
    </div>
  );
}

export default injectIntl(AllowNotificationsDialog);
